import trajectory from './trajectory.ts'

const a = 0.064
const b = 0.5
const c = 4

export function estimateRiflePrecision (v0, bc, twist, imbalance, bulletWeight, chargeWeight, rifleWeight, zoom) {
  const t = trajectory({ v0: v0, bc: bc, range: 100 })
  const time = t[100].time
  const deflection = (24 * Math.PI * time * v0 * imbalance) / twist
  const accel = ((bulletWeight + chargeWeight) / 7000) * (v0 / rifleWeight)
  const dispersionSd = Math.sqrt(
    (a * accel) ** 2 +
    (b * deflection) ** 2 +
    (c / zoom) ** 2
  )
  const groupSize = dispersionSd * 2.1
  return groupSize
}

export function estimateRiflePrecisionSimple (v0, bulletWeight, chargeWeight, rifleWeight) {
  const accel = ((bulletWeight + chargeWeight) / 7000) * (v0 / rifleWeight)
  const precision = (0.131 * accel) + 0.185
  return precision
}
